import {
    HStack,
} from "@chakra-ui/react";
import * as React from "react";
import { signIn, signOut, useSession } from "next-auth/client";
import NextLink from "next/link";
import {
    EmailShareButton,
    FacebookShareButton,
    HatenaShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    LivejournalShareButton,
    MailruShareButton,
    OKShareButton,
    PinterestShareButton,
    PocketShareButton,
    RedditShareButton,
    TelegramShareButton,
    TumblrShareButton,
    TwitterShareButton,
    ViberShareButton,
    VKShareButton,
    WhatsappShareButton,
    WorkplaceShareButton
} from "react-share";
import {
    FacebookShareCount,
    HatenaShareCount,
    OKShareCount,
    PinterestShareCount,
    RedditShareCount,
    TumblrShareCount,
    VKShareCount
} from "react-share";
import {
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    HatenaIcon,
    InstapaperIcon,
    LineIcon,
    LinkedinIcon,
    LivejournalIcon,
    MailruIcon,
    OKIcon,
    PinterestIcon,
    PocketIcon,
    RedditIcon,
    TelegramIcon,
    TumblrIcon,
    TwitterIcon,
    ViberIcon,
    VKIcon,
    WeiboIcon,
    WhatsappIcon,
    WorkplaceIcon
} from "react-share";

export const LinkShare = ({ title, url, position="flex-end" }) => {
    
    
    return (

        <HStack spacing={2} w="100%" justifyContent={position}>
            <TwitterShareButton title={title} url={url} >
                <TwitterIcon size={32} round />
            </TwitterShareButton>
            <FacebookShareButton title={title} url={url} >
                <FacebookIcon size={32} round />
            </FacebookShareButton>
            <WhatsappShareButton title={title} url={url} >
                <WhatsappIcon size={32} round />
            </WhatsappShareButton>
            <TelegramShareButton title={title} url={url} >
                <TelegramIcon size={32} round />
            </TelegramShareButton>
            <EmailShareButton title={title} url={url} >
                <EmailIcon size={32} round />
            </EmailShareButton>
        </HStack>
    );
};
